import {
  BaseQueryResponse2,
  ResourceNotFoundError,
  Response,
  ResponseApolloErrorMapping,
} from '@contexts/Shared';
import { useLazyQuery } from '@apollo/client';
import { mapExposedDocumentationDtoToDomain } from '../data-mappers';
import {
  ExposedDocumentationRequestDto,
  ExposedDocumentationResponseDto,
} from '../dtos';
import { getExposedDocumentation } from '../schemas';
import {
  DocumentsQueryActions,
  ExposedDocumentation,
  GetExposedDocumentationQuery,
} from './../../../domain';
import { useMemo } from 'react';

export const GqlDocumentsQueryActions: DocumentsQueryActions = {
  useGetExposedDocumentation: (): BaseQueryResponse2<
    GetExposedDocumentationQuery,
    ExposedDocumentation
  > => {
    const [action, { data, loading, error, refetch }] = useLazyQuery<
      ExposedDocumentationResponseDto,
      ExposedDocumentationRequestDto
    >(getExposedDocumentation, {
      errorPolicy: 'all',
    });

    const result: Response<ExposedDocumentation> = useMemo(
      () =>
        !!error
          ? new Response.Failure(ResponseApolloErrorMapping(error))
          : !data
          ? Response.notPerformed
          : !!data.exposedDocumentation?.id
          ? new Response.Success(
              mapExposedDocumentationDtoToDomain(data.exposedDocumentation)
            )
          : new Response.Failure(
              new ResourceNotFoundError('exposedDocumentation')
            ),
      [data, error]
    );

    const recall = async (): Promise<void> => refetch().then(() => void 0);

    return {
      loading,
      recall,
      result,
      get: (query: GetExposedDocumentationQuery) => {
        action({
          variables: {
            creditStudyId: query.creditStudyId.value,
          },
        });
      },
    };
  },
};
